import React from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

import { CONTACT } from "../data/content";

const initials = (name = "") =>
  name
    .split(/[\s.@]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "NA";

/**
 * Signed-in landing page. Deliberately minimal, matching v1's behaviour —
 * it confirms the session and points to the things a signed-in colleague
 * actually needs.
 */
function Login() {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  const account = instance.getActiveAccount() || accounts[0];
  const email = account?.username || "";
  const name = account?.name || email;

  const signOut = () => {
    instance
      .logoutPopup()
      .catch(() => {})
      .finally(() => navigate("/"));
  };

  return (
    <section className="band">
      <div className="wrap">
        <div className="head" style={{ marginBottom: 28 }}>
          <span className="mono key">Signed in with Microsoft Entra ID</span>
          <h2>Welcome to the portal</h2>
          <p className="sub">
            {account
              ? "You have successfully signed in using your New Age Services account."
              : "You have successfully logged in using Microsoft Entra ID."}
          </p>
        </div>

        {account && (
          <div className="account">
            <div className="avatar">{initials(name)}</div>
            <div style={{ flex: 1 }}>
              <h3 style={{ fontSize: 18 }}>{name}</h3>
              <p className="mono" style={{ color: "var(--blue-pale)" }}>{email}</p>
            </div>
            <button type="button" className="btn ghost" onClick={signOut}>
              Sign out
            </button>
          </div>
        )}

        <div className="quick">
          <a href="/Services/Services">
            <span className="ic">
              <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                <rect x="2" y="3" width="12" height="8.5" rx="1.4" fill="none" stroke="#9DB6F7" strokeWidth="1.5" />
                <path d="M6 13.5h4" stroke="#9DB6F7" strokeWidth="1.5" />
              </svg>
            </span>
            <h4>Service catalogue</h4>
            <p>Every practice, solution and detail sheet in one place.</p>
          </a>
          <a href="/JobAvailability/JobAvailability">
            <span className="ic">
              <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                <rect x="2" y="4.6" width="12" height="8.4" rx="1.6" fill="none" stroke="#9DB6F7" strokeWidth="1.5" />
                <path d="M6 4.6V3.4h4v1.2" fill="none" stroke="#9DB6F7" strokeWidth="1.5" />
              </svg>
            </span>
            <h4>Current openings</h4>
            <p>Live roles from the hiring sheet, with the application flow.</p>
          </a>
          <a href={`mailto:${CONTACT.email}`}>
            <span className="ic">
              <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                <rect x="1.8" y="3.4" width="12.4" height="9.2" rx="1.6" fill="none" stroke="#9DB6F7" strokeWidth="1.5" />
                <path d="m2.4 4.4 5.6 4.2 5.6-4.2" fill="none" stroke="#9DB6F7" strokeWidth="1.5" />
              </svg>
            </span>
            <h4>Reach the team</h4>
            <p>{CONTACT.email}</p>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Login;
